export type TypePositionOfPager = 'inside-center' | 'inside-left' | 'inside-right' | 'outside-center' | 'outside-left' | 'outside-right';
export type TypeOfScroll = 'free' | 'pager';
export type TypeOfTheme = 'dark-theme' | 'light-theme';
export type TypeOfArrow = 'custom-icon' | 'icon' | 'none' | 'title';

export const SLICE_SLIDER_DEFAULT_DELAY = 3;
export const SLICE_SLIDER_DEFAULT_NUMBER_OF_SLIDES = 1;

export interface SlotResponsiveConfig extends Partial<Exclude<Slot, 'responsiveConfig'>> {
    id: string;
}

export interface Slot {
    id?: string;
    hidden: boolean;
    flexGrow: string;
    flexShrink: string;
    flexBasis: string;
    flexDirection: string;
    width: string;
    height: string;
    minHeight: string;
    maxHeight: string;
    minWidth: string;
    maxWidth: string;
    responsiveConfig: [SlotResponsiveConfig];
}
